import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that scrolls to the top of the page
 * whenever the route changes. Works for all route transitions including:
 * - Event page to Community page
 * - Community page to Event page
 * - Community page to Events list page
 * - Any other route changes
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame to ensure scroll happens after DOM updates
    requestAnimationFrame(() => {
      // Scroll both window and document element for maximum compatibility
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto' // Instant scroll, not smooth
      });
      
      // Also scroll document element for better compatibility
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      
      // Scroll body element as well (fallback)
      if (document.body) {
        document.body.scrollTop = 0;
      }
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;

